import React, { useEffect, useState } from 'react';
import YearLevelBadge from '../components/YearLevelBadge';
import { getSessionRolesFromMap } from '../workspace/selectors';
import { resolveStudents } from '../utils/studentResolution';
import { resolveSessionSchoolName } from '../utils/sessionSchoolName';

export function DashboardSPOC({
  cohorts, sessions, spocTasks, currentSpocId,
  handleOpenOutcomeForm, setNominationsCohortId,
  setNomChairId, setNomPresenter1, setNomPresenter2, setNomPresenter3, setNomPresenter4,
  setNomMentor1, setNomMentor2, setNomMentor3, setNomMentor4,
  setShow4thPresenter, setShow4thMentor,
  setYear2NominationsCohortId,
  setActiveTab, setSelectedCohort, setCohortDetailTab,
  onSessionClick,
}) {
  return (
    <div>
      <div className="dashboard-title-row animate-fade-in">
        <div>
          <h1 className="dashboard-title">SPOC Operations Console</h1>
          <p className="dashboard-subtitle">Manage role nominations, log session outcomes, and track student progress.</p>
        </div>
      </div>

      <div style={{ marginBottom: '32px' }} className="animate-fade-in">
        <h2 className="section-title">⚠️ Pending Actions Queue</h2>
        {spocTasks.filter(t => cohorts.filter(c => String(c.spocId) === String(currentSpocId)).some(c => c.id === t.cohortId)).length > 0 ? (
          <div className="pending-tasks-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
            {spocTasks
              .filter(t => cohorts.filter(c => String(c.spocId) === String(currentSpocId)).some(c => c.id === t.cohortId))
              .map(task => {
                const isRed = task.timeLeftHours < 12;
                return (
                  <div
                    key={task.id}
                    className={`task-countdown-card clickable ${isRed ? 'red-alert' : 'amber-alert'}`}
                    onClick={() => {
                      if (task.type === 'post_session_log') {
                        handleOpenOutcomeForm(task.sessionId);
                      } else if (task.type === 'nominations') {
                        setNominationsCohortId(task.cohortId);
                        setNomChairId('');
                        setNomPresenter1(''); setNomPresenter2(''); setNomPresenter3(''); setNomPresenter4('');
                        setNomMentor1(''); setNomMentor2(''); setNomMentor3(''); setNomMentor4('');
                        setShow4thPresenter(false);
                        setShow4thMentor(false);
                        setActiveTab('nominations');
                        window.location.hash = '#/nominations';
                      } else if (task.type === 'year2_nominations') {
                        setYear2NominationsCohortId?.(task.cohortId);
                        setActiveTab('year2_nominations');
                        window.location.hash = '#/year2_nominations';
                      }
                    }}
                    style={{ cursor: 'pointer', padding: '20px', borderLeft: '4px solid' }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 'bold' }}>{task.title}</h3>
                        <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: 'var(--neutral-600)' }}>
                          {task.sessionName}
                        </p>
                      </div>
                      <span className={`task-badge-pill ${isRed ? 'red' : 'amber'}`}>
                        ⏰ {task.timeLeftHours}h left
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="empty-state-card" style={{ padding: '32px' }}>
            <div className="empty-state-icon-wrapper" style={{ color: '#10b981', background: 'rgba(16, 185, 129, 0.1)', width: '44px', height: '44px' }}>
              <span>✓</span>
            </div>
            <h3 className="empty-state-heading" style={{ fontSize: '14px', marginTop: '12px' }}>No pending tasks</h3>
            <p className="empty-state-description" style={{ fontSize: '12.5px' }}>Your logs and role nominations are fully up to date.</p>
          </div>
        )}
      </div>

      <div className="dashboard-grid animate-fade-in">
        <div className="dashboard-main-col">
          <h2 className="section-title">📅 Today's Session</h2>
          {(() => {
            const assignedCohortsIds = cohorts.filter(c => String(c.spocId) === String(currentSpocId)).map(c => c.id);
            const todaySess = sessions.find(s => assignedCohortsIds.includes(s.cohortId) && s.status === 'Planned') ||
                              sessions.find(s => assignedCohortsIds.includes(s.cohortId) && s.status === 'Completed');
            if (todaySess) {
              const todaySchoolName = resolveSessionSchoolName(todaySess, [], cohorts);
              return (
                <div
                  className="today-session-accent-card"
                  onClick={() => onSessionClick && onSessionClick(todaySess)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="today-session-accent-band"></div>
                  <div className="today-session-card-body">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <span className="today-session-type-badge">{todaySess.sessionType}</span>
                        <h3 className="today-session-title">{todaySess.cohortName}</h3>
                      </div>
                      <span className={`status-pill ${todaySess.status.toLowerCase()}`}>{todaySess.status}</span>
                    </div>
                    <div className="today-session-meta-grid">
                      <div>🏫 School: <strong>{todaySchoolName || '—'}</strong></div>
                      <div>🕒 Slot: <strong>{todaySess.timeSlot}</strong></div>
                      <div>📅 Date: <strong>{todaySess.scheduledAt.split(/[T ]/)[0]}</strong></div>
                    </div>
                    <div className="today-session-footer">
                      <a href={todaySess.meetingLink} target="_blank" rel="noopener noreferrer" className="btn-join-room-spoc" onClick={(e) => e.stopPropagation()}>
                        Join Fellowship Zoom Room
                      </a>
                    </div>
                  </div>
                </div>
              );
            }
            return (
              <div className="empty-state-card">
                <p className="empty-state-description">No active sessions scheduled for today.</p>
              </div>
            );
          })()}
        </div>

        <div className="dashboard-side-col">
          <h2 className="section-title">👥 My Cohorts Summary</h2>
          <div className="dashboard-list-card cohorts-stack">
            {cohorts.filter(c => String(c.spocId) === String(currentSpocId)).map(c => (
              <div
                key={c.id}
                className="cohort-row-item"
                onClick={() => {
                  setActiveTab('my_cohorts');
                  setSelectedCohort(c);
                  setCohortDetailTab('students');
                  window.location.hash = `#/my_cohorts/${c.id}/students`;
                }}
                style={{ cursor: 'pointer' }}
              >
                <div className="cohort-row-info">
                  <span className="cohort-row-name">{c.name}</span>
                  <span className="cohort-row-subtext">{c.schoolName} • {c.studentIds.length} Students</span>
                </div>
                <span className="status-pill active">{c.status}</span>
              </div>
            ))}
            {cohorts.filter(c => String(c.spocId) === String(currentSpocId)).length === 0 && (
              <div style={{ padding: '16px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '13px' }}>
                No cohorts assigned.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function MyCohortsSPOC({ cohorts, sessions, currentSpocId, setSelectedCohort, setCohortDetailTab }) {
  return (
    <div className="animate-fade-in">
      <div className="dashboard-title-row">
        <div>
          <h1 className="dashboard-title">My Assigned Cohorts</h1>
          <p className="dashboard-subtitle">Select a cohort to view enrolled students, sessions schedules, and pending tasks.</p>
        </div>
      </div>

      <div className="dashboard-stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
        {cohorts.filter(c => String(c.spocId) === String(currentSpocId)).map(c => (
          <div
            key={c.id}
            className="cohort-row-item"
            onClick={() => {
              setSelectedCohort(c);
              setCohortDetailTab('students');
              window.location.hash = `#/my_cohorts/${c.id}/students`;
            }}
            style={{
              cursor: 'pointer', padding: '24px', borderRadius: 'var(--border-radius)',
              border: '1.5px solid var(--border-color)', background: 'var(--bg-card)',
              display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '12px'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <h3 style={{ margin: 0, fontSize: '16px', color: 'var(--primary-navy)', fontWeight: 'bold' }}>{c.name}</h3>
                  <YearLevelBadge levelYear={c.levelYear} />
                </div>
                <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: 'var(--text-muted)' }}>🏫 {c.schoolName}</p>
              </div>
              <span className="status-pill active">{c.status}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', color: 'var(--neutral-600)', paddingTop: '8px', borderTop: '1px solid var(--neutral-100)' }}>
              <span>👥 <strong>{c.studentIds.length}</strong> Enrolled Students</span>
              <span>📅 <strong>{sessions.filter(s => s.cohortId === c.id).length}</strong> Total Sessions</span>
            </div>
          </div>
        ))}
        {cohorts.filter(c => String(c.spocId) === String(currentSpocId)).length === 0 && (
          <div className="empty-state-card" style={{ gridColumn: '1 / -1' }}>
            <p className="empty-state-description">No cohorts assigned to your account.</p>
          </div>
        )}
      </div>
    </div>
  );
}

const sessionStatusKey = (status) => String(status || '').toLowerCase();

/** Year 1 nominations editable on planned + live (and completed). Only cancelled is locked. */
const isNominationEditable = (session) => {
  const status = sessionStatusKey(session.status);
  return status === 'planned' || status === 'live' || status === 'completed';
};

const isOutcomeEditable = (session) => sessionStatusKey(session.status) !== 'cancelled';

export function NominationsSPOC({
  cohorts, sessions, allStudents, sessionRoles, currentSpocId,
  nominationsCohortId, nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, show4thPresenter,
  nomMentor1, nomMentor2, nomMentor3, nomMentor4, show4thMentor,
  setNominationsCohortId, setNomChairId,
  setNomPresenter1, setNomPresenter2, setNomPresenter3, setNomPresenter4, setShow4thPresenter,
  setNomMentor1, setNomMentor2, setNomMentor3, setNomMentor4, setShow4thMentor,
  handleSubmitNominations,
  handleOpenOutcomeForm,
}) {
  const activeCohortObj = cohorts.find(c => c.id === nominationsCohortId);
  const cohortStudents = activeCohortObj
    ? resolveStudents(activeCohortObj.studentIds, allStudents)
    : [];

  // Backend already scopes /cohorts to what the acting user (SPOC or auditor)
  // is allowed to see, so only re-filter by spocId when acting as SPOC.
  const myCohorts = cohorts.filter(
    (c) => (!currentSpocId || String(c.spocId) === String(currentSpocId)) && c.levelYear === 'Year 1'
  );
  const [editingSessionId, setEditingSessionId] = useState(null);

  useEffect(() => {
    if (!nominationsCohortId && myCohorts.length > 0) {
      setNominationsCohortId(myCohorts[0].id);
    }
  }, [nominationsCohortId, myCohorts, setNominationsCohortId]);

  const cohortSessions = sessions
    .filter(s => {
      if (String(s.cohortId) === String(nominationsCohortId)) return true;
      if (s.groupId && (s.groupCohortIds || []).map(String).includes(String(nominationsCohortId))) return true;
      return false;
    })
    .sort((a, b) => a.scheduledAt.localeCompare(b.scheduledAt));

  const rolesForSession = (sessionId) => getSessionRolesFromMap(sessionRoles, sessionId, nominationsCohortId);

  const clearNominationForm = () => {
    setNomChairId('');
    setNomPresenter1(''); setNomPresenter2(''); setNomPresenter3(''); setNomPresenter4('');
    setNomMentor1(''); setNomMentor2(''); setNomMentor3(''); setNomMentor4('');
    setShow4thPresenter(false); setShow4thMentor(false);
  };

  const handleCohortChange = (val) => {
    setNominationsCohortId(val);
    setEditingSessionId(null);
    clearNominationForm();
  };

  const loadNominationForm = (sessionId) => {
    const existing = rolesForSession(sessionId);
    setNomChairId(existing.chairId || '');
    setNomPresenter1(existing.presenterIds?.[0] || '');
    setNomPresenter2(existing.presenterIds?.[1] || '');
    setNomPresenter3(existing.presenterIds?.[2] || '');
    setNomPresenter4(existing.presenterIds?.[3] || '');
    setShow4thPresenter(!!existing.presenterIds?.[3]);
    setNomMentor1(existing.mentorIds?.[0] || '');
    setNomMentor2(existing.mentorIds?.[1] || '');
    setNomMentor3(existing.mentorIds?.[2] || '');
    setNomMentor4(existing.mentorIds?.[3] || '');
    setShow4thMentor(!!existing.mentorIds?.[3]);
    setEditingSessionId(sessionId);
  };

  const handleStartNominations = (sessionId) => {
    clearNominationForm();
    setEditingSessionId(sessionId);
  };

  const handleEditNominations = (sessionId) => {
    loadNominationForm(sessionId);
  };

  const handleCancelEdit = () => {
    setEditingSessionId(null);
    clearNominationForm();
  };

  const handleFormSubmit = async (e, sessionId) => {
    const saved = await handleSubmitNominations(e, sessionId);
    if (saved) {
      setEditingSessionId(null);
    }
  };

  const studentName = (id) => {
    const s = allStudents.find(s => String(s.id) === String(id));
    return s ? s.name : `#${id}`;
  };

  const renderOutcomesSummary = (roles) => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', fontSize: '13px' }}>
      <div>
        <div style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Challengers</div>
        <div style={{ color: 'var(--neutral-800)', fontWeight: 500 }}>
          {(roles.challengerIds || []).length > 0
            ? (roles.challengerIds || []).map(id => studentName(id)).join(', ')
            : '—'}
        </div>
      </div>
      <div>
        <div style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Chair score</div>
        <div style={{ color: 'var(--neutral-800)', fontWeight: 500 }}>{roles.chairScore || '—'}</div>
      </div>
    </div>
  );

  const renderRolesSummary = (roles) => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', fontSize: '13px' }}>
      <div>
        <div style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Chair</div>
        <div style={{ color: 'var(--neutral-800)', fontWeight: 500 }}>{roles.chairId ? studentName(roles.chairId) : '—'}</div>
      </div>
      <div>
        <div style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Presenters</div>
        <div style={{ color: 'var(--neutral-800)', fontWeight: 500 }}>
          {(roles.presenterIds || []).length > 0
            ? (roles.presenterIds || []).map(id => studentName(id)).join(', ')
            : '—'}
        </div>
      </div>
      <div>
        <div style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>Mentors</div>
        <div style={{ color: 'var(--neutral-800)', fontWeight: 500 }}>
          {(roles.mentorIds || []).length > 0
            ? (roles.mentorIds || []).map(id => studentName(id)).join(', ')
            : '—'}
        </div>
      </div>
    </div>
  );

  const renderNominationForm = (sessionId, isUpdate) => (
    <form onSubmit={(e) => handleFormSubmit(e, sessionId)}>
      <div className="form-section-container">
        <h3 className="form-section-title">Chair Role</h3>
        <hr className="form-section-divider" />
        <div className="form-field-group">
          <label htmlFor={`nomChair-${sessionId}`}>Chair (1) *</label>
          <select id={`nomChair-${sessionId}`} className="form-control-select" value={nomChairId} onChange={(e) => setNomChairId(e.target.value)} required>
            <option value="">-- Nominate Chair --</option>
            {cohortStudents.filter(stud => ![nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor1, nomMentor2, nomMentor3, nomMentor4].includes(stud.id)).map(stud => (
              <option key={stud.id} value={stud.id}>{stud.name}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-section-container" style={{ marginTop: '24px' }}>
        <h3 className="form-section-title">Presenters</h3>
        <hr className="form-section-divider" />
        {[
          { id: `nomPresenter1-${sessionId}`, label: 'Presenter 1 *', value: nomPresenter1, setter: setNomPresenter1, others: [nomChairId, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor1, nomMentor2, nomMentor3, nomMentor4] },
          { id: `nomPresenter2-${sessionId}`, label: 'Presenter 2 *', value: nomPresenter2, setter: setNomPresenter2, others: [nomChairId, nomPresenter1, nomPresenter3, nomPresenter4, nomMentor1, nomMentor2, nomMentor3, nomMentor4] },
          { id: `nomPresenter3-${sessionId}`, label: 'Presenter 3 *', value: nomPresenter3, setter: setNomPresenter3, others: [nomChairId, nomPresenter1, nomPresenter2, nomPresenter4, nomMentor1, nomMentor2, nomMentor3, nomMentor4] },
        ].map(({ id, label, value, setter, others }) => (
          <div key={id} className="form-field-group">
            <label htmlFor={id}>{label}</label>
            <select id={id} className="form-control-select" value={value} onChange={(e) => setter(e.target.value)} required>
              <option value="">-- {label.replace(' *', '')} --</option>
              {cohortStudents.filter(stud => !others.includes(stud.id)).map(stud => (
                <option key={stud.id} value={stud.id}>{stud.name}</option>
              ))}
            </select>
          </div>
        ))}
        {!show4thPresenter && (
          <button type="button" className="btn-form-toggle-outlined" onClick={() => setShow4thPresenter(true)}>+ Add 4th Presenter (Optional)</button>
        )}
        {show4thPresenter && (
          <div className="form-field-group animate-fade-in">
            <label htmlFor={`nomPresenter4-${sessionId}`}>Presenter 4 (Optional)</label>
            <select id={`nomPresenter4-${sessionId}`} className="form-control-select" value={nomPresenter4} onChange={(e) => setNomPresenter4(e.target.value)} required={show4thPresenter}>
              <option value="">-- Presenter 4 --</option>
              {cohortStudents.filter(stud => ![nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomMentor1, nomMentor2, nomMentor3, nomMentor4].includes(stud.id)).map(stud => (
                <option key={stud.id} value={stud.id}>{stud.name}</option>
              ))}
            </select>
            <button type="button" className="btn-form-toggle-outlined remove-btn" onClick={() => { setShow4thPresenter(false); setNomPresenter4(''); }}>Remove 4th Presenter</button>
          </div>
        )}
      </div>

      <div className="form-section-container" style={{ marginTop: '24px', marginBottom: '32px' }}>
        <h3 className="form-section-title">Mentors</h3>
        <hr className="form-section-divider" />
        {[
          { id: `nomMentor1-${sessionId}`, label: 'Mentor 1 *', value: nomMentor1, setter: setNomMentor1, others: [nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor2, nomMentor3, nomMentor4] },
          { id: `nomMentor2-${sessionId}`, label: 'Mentor 2 *', value: nomMentor2, setter: setNomMentor2, others: [nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor1, nomMentor3, nomMentor4] },
          { id: `nomMentor3-${sessionId}`, label: 'Mentor 3 *', value: nomMentor3, setter: setNomMentor3, others: [nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor1, nomMentor2, nomMentor4] },
        ].map(({ id, label, value, setter, others }) => (
          <div key={id} className="form-field-group">
            <label htmlFor={id}>{label}</label>
            <select id={id} className="form-control-select" value={value} onChange={(e) => setter(e.target.value)} required>
              <option value="">-- {label.replace(' *', '')} --</option>
              {cohortStudents.filter(stud => !others.includes(stud.id)).map(stud => (
                <option key={stud.id} value={stud.id}>{stud.name}</option>
              ))}
            </select>
          </div>
        ))}
        {!show4thMentor && (
          <button type="button" className="btn-form-toggle-outlined" onClick={() => setShow4thMentor(true)}>+ Add 4th Mentor (Optional)</button>
        )}
        {show4thMentor && (
          <div className="form-field-group animate-fade-in">
            <label htmlFor={`nomMentor4-${sessionId}`}>Mentor 4 (Optional)</label>
            <select id={`nomMentor4-${sessionId}`} className="form-control-select" value={nomMentor4} onChange={(e) => setNomMentor4(e.target.value)} required={show4thMentor}>
              <option value="">-- Mentor 4 --</option>
              {cohortStudents.filter(stud => ![nomChairId, nomPresenter1, nomPresenter2, nomPresenter3, nomPresenter4, nomMentor1, nomMentor2, nomMentor3].includes(stud.id)).map(stud => (
                <option key={stud.id} value={stud.id}>{stud.name}</option>
              ))}
            </select>
            <button type="button" className="btn-form-toggle-outlined remove-btn" onClick={() => { setShow4thMentor(false); setNomMentor4(''); }}>Remove 4th Mentor</button>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <button type="submit" className="btn-submit-nominations">
          {isUpdate ? 'Update Year 1 Role Nominations' : 'Submit Year 1 Role Nominations'}
        </button>
        {isUpdate && (
          <button type="button" className="btn-form-toggle-outlined" onClick={handleCancelEdit}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );

  return (
    <div className="animate-fade-in">
      <div className="dashboard-title-row">
        <div>
          <h1 className="dashboard-title">Year 1 Role Nominations</h1>
          <p className="dashboard-subtitle">Nominate roles before a session; log challengers and awards when you are ready. The PA manages scheduling.</p>
        </div>
      </div>

      <div style={{ marginBottom: '24px', padding: '14px 18px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', color: 'var(--neutral-700)', lineHeight: 1.55 }}>
        <strong>Before the session:</strong> nominate chair, presenters, and mentors for any session.<br />
        <strong>After the session (your discretion):</strong> log challengers, best-award picks, and chair score. There is no fixed deadline — record outcomes when it suits your cohort.
      </div>

      {/* Cohort picker */}
      <div style={{ marginBottom: '28px', maxWidth: '340px' }}>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>Cohort</label>
        <select
          className="form-control-select"
          value={nominationsCohortId}
          onChange={(e) => handleCohortChange(e.target.value)}
        >
          {myCohorts.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* Session timeline */}
      {cohortSessions.length === 0 ? (
        <div style={{ color: '#dc2626', fontWeight: 600, fontSize: '13px', padding: '20px 0' }}>
          No sessions scheduled for this cohort yet. Ask the PA to add sessions first.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {cohortSessions.map((sess) => {
            const statusKey = sessionStatusKey(sess.status);
            const isCompleted = statusKey === 'completed';
            const isCancelled = statusKey === 'cancelled';
            const isLive = statusKey === 'live';
            const isEditable = isNominationEditable(sess);
            const roles = rolesForSession(sess.id);
            const isGroupSession = Boolean(sess.groupId);
            const hasNominations = Boolean(roles.chairId);
            const hasOutcomes = (roles.challengerIds || []).length > 0 || Boolean(roles.chairScore);
            const canLogOutcomes = isOutcomeEditable(sess);
            const isEditing = String(editingSessionId) === String(sess.id);
            const dateStr = sess.scheduledAt.split(/[T ]/)[0];

            const borderColor = isCompleted ? '#10b981'
              : isLive ? '#f59e0b'
              : isCancelled ? '#ef4444'
              : 'var(--primary-navy)';

            const headerBg = isCompleted ? '#f0fdf4'
              : isLive ? '#fffbeb'
              : isCancelled ? '#f9fafb'
              : '#eff6ff';

            const statusIcon = isCompleted ? '✅' : isLive ? '🔴' : isCancelled ? '❌' : '📝';

            return (
              <div key={sess.id} style={{ border: `1px solid ${borderColor}`, borderLeft: `4px solid ${borderColor}`, borderRadius: '10px', overflow: 'hidden' }}>
                <div style={{ background: headerBg, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontSize: '18px' }}>{statusIcon}</span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '14px', color: 'var(--neutral-900)' }}>{sess.sessionType}</div>
                      <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>
                        {dateStr} • {sess.timeSlot}
                        {isGroupSession && activeCohortObj ? ` • ${activeCohortObj.name}` : ''}
                        {isGroupSession && sess.groupName ? ` (Group: ${sess.groupName})` : ''}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {isEditable && isEditing && (
                      <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1d4ed8', padding: '3px 10px', borderRadius: '999px', fontWeight: 700 }}>Editing</span>
                    )}
                    {isEditable && hasNominations && !isEditing && (
                      <span style={{ fontSize: '11px', background: '#dcfce7', color: '#15803d', padding: '3px 10px', borderRadius: '999px', fontWeight: 700 }}>Nominated</span>
                    )}
                    {isEditable && !hasNominations && !isEditing && (
                      <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1d4ed8', padding: '3px 10px', borderRadius: '999px', fontWeight: 700 }}>Nominate</span>
                    )}
                    {isLive && (
                      <span style={{ fontSize: '11px', background: '#fef3c7', color: '#b45309', padding: '3px 10px', borderRadius: '999px', fontWeight: 600 }}>Live</span>
                    )}
                    {isCompleted && (
                      <span style={{ fontSize: '11px', background: '#dcfce7', color: '#15803d', padding: '3px 10px', borderRadius: '999px', fontWeight: 600 }}>Completed</span>
                    )}
                    {isCancelled && (
                      <span style={{ fontSize: '11px', background: '#fee2e2', color: '#b91c1c', padding: '3px 10px', borderRadius: '999px', fontWeight: 600 }}>Cancelled</span>
                    )}
                    {statusKey === 'planned' && (
                      <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1d4ed8', padding: '3px 10px', borderRadius: '999px', fontWeight: 600 }}>Planned</span>
                    )}
                  </div>
                </div>

                <div style={{ padding: '18px' }}>
                  {isCancelled && (
                    <p style={{ color: '#b91c1c', fontSize: '13px', margin: '0 0 12px' }}>
                      This session was cancelled.
                    </p>
                  )}

                  {(isCompleted || (isEditable && hasNominations && !isEditing)) && (
                    <div style={{ marginBottom: isEditable ? '14px' : 0 }}>
                      {hasNominations ? (
                        <div style={{ background: isEditable ? '#ecfdf5' : '#f9fafb', border: `1px solid ${isEditable ? '#6ee7b7' : '#e5e7eb'}`, borderRadius: '10px', padding: '16px 18px' }}>
                          {hasNominations && (
                            <div style={{ fontSize: '14px', color: 'var(--neutral-800)', fontWeight: 700, marginBottom: '12px' }}>
                              Year 1 Role Nominations
                            </div>
                          )}
                          {renderRolesSummary(roles)}
                          {isEditable && (
                            <button type="button" className="btn-form-toggle-outlined" style={{ marginTop: '14px' }} onClick={() => handleEditNominations(sess.id)}>
                              Edit Year 1 Role Nominations
                            </button>
                          )}
                        </div>
                      ) : isCompleted ? (
                        <p style={{ color: 'var(--text-muted)', fontSize: '13px', margin: 0 }}>No nominations recorded for this session.</p>
                      ) : null}
                    </div>
                  )}

                  {isEditable && isEditing && (
                    <div>
                      {renderNominationForm(sess.id, hasNominations)}
                    </div>
                  )}

                  {isEditable && !hasNominations && !isEditing && (
                    <button type="button" className="btn-form-toggle-outlined" onClick={() => handleStartNominations(sess.id)}>
                      Nominate Year 1 Roles for This Session
                    </button>
                  )}

                  {canLogOutcomes && (
                    <div style={{ marginTop: '18px', paddingTop: '18px', borderTop: '1px solid #e5e7eb' }}>
                      {hasOutcomes ? (
                        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '16px 18px' }}>
                          <div style={{ fontSize: '14px', color: 'var(--neutral-800)', fontWeight: 700, marginBottom: '12px' }}>
                            Year 1 Session Outcomes
                          </div>
                          {renderOutcomesSummary(roles)}
                          <button
                            type="button"
                            className="btn-form-toggle-outlined"
                            style={{ marginTop: '14px' }}
                            onClick={() => handleOpenOutcomeForm(sess.id)}
                          >
                            Edit Year 1 Session Outcomes
                          </button>
                        </div>
                      ) : (
                        <button type="button" className="btn-form-toggle-outlined" onClick={() => handleOpenOutcomeForm(sess.id)}>
                          Log Year 1 Session Outcomes
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
